import {Component} from "@angular/core";

@Component({
  selector: 'fabric8-deployments-list-toolbar',
  templateUrl: './list-toolbar.deployment.component.html',
  styleUrls: ['./list-toolbar.deployment.component.scss'],
})
export class DeploymentsListToolbarComponent {

}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
